import React, {
  createContext,
  useContext,
  useState,
  type ReactNode,
} from "react";

import { useCurrentDealerId } from "~/shared/hooks/useCurrentDealerId";

export type DealerId = string | null;

export type DealerDataContextValue = {
  DealerId;
};

export type DealerActionsContextValue = {
  setDealerIdToContext: (id: DealerId) => void;
};

export const DealerDataContext = createContext<DealerDataContextValue | null>(
  null
);

export const DealerActionsContext =
  createContext<DealerActionsContextValue | null>(null);

export const DealerContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const currentDealerId = useCurrentDealerId();
  const [dealerId, setDealerId] = useState<DealerId>(currentDealerId || null);

  const setDealerIdToContext = (id: DealerId) => {
    setDealerId(id);
  };

  const actionsValue = { setDealerIdToContext };
  const dataValue = { DealerId: dealerId };

  return (
    <DealerActionsContext.Provider value={actionsValue}>
      <DealerDataContext.Provider value={dataValue}>
        {children}
      </DealerDataContext.Provider>
    </DealerActionsContext.Provider>
  );
};

export function useDealerData(): DealerDataContextValue {
  const ctx = useContext(DealerDataContext);
  if (!ctx) {
    throw new Error("useDealerData must be used within DealerContextProvider");
  }
  return ctx;
}

export function useDealerActions(): DealerActionsContextValue {
  const ctx = useContext(DealerActionsContext);
  if (!ctx) {
    throw new Error(
      "useDealerActions must be used within DealerContextProvider"
    );
  }
  return ctx;
}
